<!--用电阈值设置-->
<template>
  <div class="calender_box">
    <span class="span">
      <div class="calender_tit">
        <div class="text">用电阈值设置<span style="margin-left:10px;">单位：度</span> <el-button class="btn" type="primary"
            size="mini" @click="submit">保存设置</el-button>
        </div>
      </div>
      <div class="calender">
        <div class="ul">
          <div class="li" v-for="(item,index) in ul" :key="index" :style="{ borderColor: item.color}">
            <div class="l">{{!index?0:''}}</div>
            <el-input size="mini" class="r" v-model="item.num" placeholder="请输入内容"></el-input>
          </div>
        </div>
      </div>
    </span>
  </div>

</template>

<script type="text/javascript">
  import request from "@/api/http.js";
  export default {
    data () {
      return {
        ul: [{
          num: '100,000',
          color: '#19E92E',
          bgc: '#baf8c0',
        },{
          num: '150,000',
          color: '#FFDB1D',
          bgc: '#fff4bb',
        },{
          num: '200,000',
          color: '#FF7C1D',
          bgc: '#ffd8bb',
        },{
          num: '250,000',
          color: '#FF1D1D',
          bgc: '#ffbbbb',
        },],

      }
    },

    mounted () {
      this.getList()
    },
    methods: {
      // 获取数据
      getList (v) {
        var params={
          "dataTime": new Date().getTime(),
          "unitId": this.$store.unitStore.getters.getNowUnit.id,
        }
        request({url: "/calendar/find",method: "get",params}).then(res => {
          if(res.code==200) {
            // 用电阈值
            var b=res.data.setting;
            this.ul[0].num=this.addDou(b.green.toString())
            this.ul[1].num=this.addDou(b.yellow.toString())
            this.ul[2].num=this.addDou(b.orange.toString())
            this.ul[3].num=this.addDou(b.red.toString())

          } else {
            this.$message({
              message: res.message,
              type: 'success'
            });
          }
        })
      },
      addDou (num) {
        console.log(num,'num');
        var numArr=num.split('.')
        num=numArr[0]
        var result=''
        while(num.length>3) {
          result=','+num.slice(-3)+result
          num=num.slice(0,num.length-3)
        }
        if(num) {
          result=num+result
        }
        if(numArr[1]) {
          result=result+'.'+numArr[1]
        }

        return result
      },
      // 保存
      submit (v) {
        var data={
          "green": parseInt(this.ul[0].num.replace(',',"")),
          "yellow": parseInt(this.ul[1].num.replace(',',"")),
          "orange": parseInt(this.ul[2].num.replace(',',"")),
          "unitId": this.$store.unitStore.getters.getNowUnit.id,
          "red": parseInt(this.ul[3].num.replace(',',"")),
        }
        console.log(data);
        request({url: "/calendar/save",method: "post",data}).then(res => {
          console.log(res);
          if(res.code==200) {
            this.$message({
              message: '修改成功',
              type: 'success'
            });
          } else {
            this.$message({
              message: res.message,
              type: 'inof'
            });
          }
        })
      },

    }
  }
</script>

<style scoped>
  .span {
    background: #fff;
    display: block;
    height: calc(100vh - 100px);
  }



  .ul {
    display: flex;
    margin-top: 35px;
    margin-left: 30px;
  }

  .ul .li {
    color: #666;
    width: 120px;
    border-bottom: 8px solid #000;
    display: flex;
    justify-content: space-between;
    margin-right: 3px;
    display: flex;
    align-items: center;
    padding-bottom: 10px;
  }

  .ul .li .r {
    width: 80px;
  }

  .calender_box {
    padding: 10px;
  }

  .calender_tit {
    padding: 21px;
    padding-bottom: 0;
    background: #fff;
  }

  .calender_tit .btn {
    float: right;
    transform: translateY(-4px);
  }

  .calender_tit .text {
    border-bottom: 2px solid #e6e6e6;
    padding-bottom: 10px;
    font-size: 16px;
    ;
  }

  .calender {
    position: relative;
    width: 100%;
    box-sizing: border-box;

  }



  .box {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    /* color: #000; */
  }

  .box .p {
    margin-top: 15px;
    margin-left: 20px;
    font-size: 16px;
  }

  .unit {
    position: absolute;
    top: 10px;
    left: 20px;
    display: flex;
    align-items: center;
  }
</style>
<style>
  .el-backtop,
  .el-calendar-table td.is-today {
    color: #000;
  }

  .el-calendar-day {
    position: relative;
  }

  .el-calendar__body thead {
    background-color: #368ED9;

  }

  .el-calendar-table thead th {
    color: #fff;
    border-right: 1px solid #fff;
    border-left: 1px solid #fff;
  }

  .el-calendar-table .el-calendar-day {
    height: 104px;
  }

  .el-calendar__header {
    border-bottom: none;
  }
</style>